import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import styles from './EmployeeList.module.scss';
import { useState } from 'react';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';
import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_EmployeeCard, UI_EmployeeCardProps } from 'ui/components/2-molecules/Card/EmployeeCard/EmployeeCard';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import classNames from 'classnames';
import ColorOptions from 'helpers/types';

export interface UI_EmployeeListProps {
	heading?: string;
	subHeading?: string;
	employees: UI_EmployeeCardProps[];
	showMoreButton?: string;
	showMoreAmount?: number;
	bgColor?: ColorOptions;
}

export const UI_EmployeeList: React.FC<UI_EmployeeListProps> = ({
	heading,
	subHeading,
	employees,
	showMoreButton,
	showMoreAmount,
	bgColor = 'white',
}) => {
	showMoreAmount = (showMoreAmount || 3) === -1 ? employees?.length : showMoreAmount || 3;
	const [amountOfEmplooyesShown, setAmountOfEmplooyesShown] = useState<number>(
		employees?.length > showMoreAmount ? showMoreAmount : employees?.length,
	);

	return (
		<div className={classNames(styles.EmployeeList, styles[`u-color___${bgColor}`])}>
			<UI_Container width="Standard">
				{heading && (
					<UI_Heading className={styles.EmployeeList_heading} headingLevel="h2" style="md">
						{heading}
					</UI_Heading>
				)}

				{subHeading && (
					<UI_Heading className={styles.EmployeeList_subHeading} headingLevel="h3">
						{subHeading}
					</UI_Heading>
				)}

				{employees && (
					<>
						<UI_Grid wrap largeGutter className={styles.EmployeeList_grid}>
							{employees.slice(0, amountOfEmplooyesShown).map((employee) => (
								<UI_GridCell mobileWidth="100" desktopWidth="33" key={employee.id}>
									<UI_EmployeeCard {...employee} />
								</UI_GridCell>
							))}
						</UI_Grid>

						{amountOfEmplooyesShown !== employees.length && (
							<div className={styles.EmployeeList_showMoreButton}>
								<UI_Button
									inheritsColor
									style="secondary"
									onClick={() => {
										if (amountOfEmplooyesShown <= employees.length - showMoreAmount) {
											setAmountOfEmplooyesShown(amountOfEmplooyesShown + showMoreAmount);
										} else {
											const difference = employees.length - amountOfEmplooyesShown;
											setAmountOfEmplooyesShown(amountOfEmplooyesShown + difference);
										}
									}}
								>
									{showMoreButton}
								</UI_Button>
							</div>
						)}
					</>
				)}
			</UI_Container>
		</div>
	);
};
